import { Component, Input } from '@angular/core';
import { LanguageModel } from '../../../shared/models/language.model';
import { CashcutDetailModel } from '../../../shared/models/cashcutDetail.model';

@Component({
  selector: 'app-cashcut-details-overview',
  templateUrl: './cashcut-details-overview.component.html',
  styleUrls: ['./cashcut-details-overview.component.scss'],
})
export class CashcutDetailsOverviewComponent {
  @Input() cashcut: CashcutDetailModel;
  @Input() language: LanguageModel;

  constructor() {}
}
